import { AUTH, LOG_OUT, SET_AUTH } from '../actions/auth';

export interface IAuthState {
  loggedIn: boolean;
  authFailed?: boolean;
  signature?: string;
  sessionId?: number;
  wallet?: string;
  network?: string;
  expires_at?: number;
}

const defaultAuthState: IAuthState = {
  loggedIn: false,
  authFailed: false,
};

const authReducer = (
  state: IAuthState = defaultAuthState,
  action: any
): IAuthState => {
  switch (action.type) {
  case AUTH:
    return {
      ...state,
      authFailed: false,
    };
  case SET_AUTH:
    return {
      ...state,
      ...action.payload,
    };
  case LOG_OUT:
    return defaultAuthState;
  default:
    return state;
  }
};

export default authReducer;
